export const PASSWORD_REFUSALS = ['WRONG_CURRENT', 'MISMATCH', 'TOO_SHORT', 'UNKNOWN'] as const;
export type PasswordRefusal = (typeof PASSWORD_REFUSALS)[number];

const isPasswordRefusal = (code: string): code is PasswordRefusal => (PASSWORD_REFUSALS as readonly string[]).includes(code);

const refusalOfCode = (code: string | null): PasswordRefusal => (code !== null && isPasswordRefusal(code) ? code : 'UNKNOWN');

export class PasswordChangeRefused extends Error {
  readonly reason: PasswordRefusal;

  constructor(message: string, code: string | null = null) {
    super(message);
    this.name = 'PasswordChangeRefused';
    this.reason = refusalOfCode(code);
  }
}

export class LanguageNotSaved extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'LanguageNotSaved';
  }
}
